import { Navigate, Route, Routes } from "react-router-dom";
import { AdminFrame, AdminLangProvider, AuthProvider, RequireAdmin } from "./context";
import AdminLayout from "./AdminLayout";
import Login from "./Login";
import Overview from "./Overview";
import Items from "./Items";
import Categories from "./Categories";
import Designer from "./Designer";
import QRPage from "./QRPage";
import Menus from "./Menus";

export default function AdminApp() {
  return (
    <AdminLangProvider>
      <AuthProvider>
        <AdminFrame>
          <Routes>
            <Route path="login" element={<Login />} />
            <Route element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
              <Route index element={<Overview />} />
              <Route path="items" element={<Items />} />
              <Route path="categories" element={<Categories />} />
              <Route path="designer" element={<Designer />} />
              <Route path="qr" element={<QRPage />} />
              <Route path="menus" element={<Menus />} />
            </Route>
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </AdminFrame>
      </AuthProvider>
    </AdminLangProvider>
  );
}
